import logo from './logo.svg';
import './App.css';
import Header from './components/Navbar';
import { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import DebugTree from './components/DebugTree';
import Spinner from './components/Spinner';

import Archive from './components/Archive';
import Help from './components/Help';
import Chart from './components/Chart';
import { Navbar } from './components/Navbar';
import MainPage from './pages/MainPage';
import DecisionPage from "./pages/DecisionPage"
import { div } from 'framer-motion/client';

import "./index.css";
import Speech from "react-text-to-speech";

function App() {
	const [data, setData] = useState({});
	const [loading, setLoading] = useState(true);
	const [activeTab, setActiveTab] = useState(0);

	useEffect(() => {
		//const url = "/api/data"
		const url="https://www.planspiel-bw.de/planspiel?getjson=1"

		fetch(url)
			.then(res => res.json())
			.then(data => {
				setData(data);
				setLoading(false);
			});
	}, [])
	
	// const renderActiveTab = () => {
	// 	console.log('render active tab')
	// 	switch (activeTab) {
	// 		case 0:
				
	// 			<Decision data={data} />
	// 			break;
	// 		case 1:
	// 			<Archive />
	// 			break;
	// 		case 2:
	// 			<Help />
	// 			break;
	// 		case 3:
	// 			<Archive />
	// 			break;
	// 		default:
	// 			<Decision data={data} />
	// 	}
	// }

	return (
		<Router>
		<div className="App" style={{ position: "relative" }}>
			{loading ? (
				<Spinner />
			) : (
				<div>
				{/* <DebugTree data={data} /> */}
				<Routes>
					<Route path="/" element={<MainPage/>}/>
					<Route path="/decision" element={<DecisionPage/>}/>
					<Route path="*" element={<MainPage/>}/>
				</Routes>
				
			
				</div>
				
			)}
			
			{/*<Navbar setActiveTab={setActiveTab}/>*/}
			{/* {renderActiveTab()} */}
			{/*<Decision data={data} />*/}
			
		</div>
		</Router>
	);
}

export default App;
